import styled from 'styled-components';
import { Loader as LoaderLayoutComponent } from '@playbookux/playbook-web-core';

const mobileLimit = (breakpoints) => `${breakpoints.sm - 1}px`;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  @media (max-width: ${({ theme }) => mobileLimit(theme.breakpoints)}) {
    overflow-y: auto;
    max-height: 45vh;
    margin: 0 -20px;
  }
`;

export const DateContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const DayBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 45px;
  margin: 7px;
  border: 2px solid ${({ theme }) => theme.color.button};
  color: ${({ theme, selectedDay }) => (!selectedDay ? theme.color.button : theme.color.buttonText)};
  font-size: ${({ theme }) => theme.fontSize.text};
  font-weight: 500;
  ${({ selectedDay, theme }) => selectedDay && `background: ${theme.color.button};`}

  :hover {
    cursor:pointer;
    color: ${({ theme }) => theme.color.buttonText};
    ${({ selectedDay, theme }) => !selectedDay && `background: ${theme.color.button};`}
  }

  @media (max-width: ${({ theme }) => mobileLimit(theme.breakpoints)}) {
    min-height: 45px;
  }
`;

export const ContainerNoSlots = styled.div`
  display: flex;
  justify-content: center;
  padding: 100px;
  color: ${({ theme }) => theme.color.text};
  font-size: ${({ theme }) => theme.fontSize.textHeader};
`;

export const Loader = styled(LoaderLayoutComponent)`
`;
